export class ModuleDataHandler {
  moduleData: any;
  numberOfDay: any;

  constructor(moduleData: any, numberOfDay: any) {
    this.moduleData = moduleData;
    this.numberOfDay = numberOfDay;
  }

  calculateTotalWorkingDays(rowIdx: number) {
    const { p_day, l_day } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'total_1',
      Number((+p_day || 0) + (+l_day || 0))
    );
  }
  //
  calculatePayAmount(rowIdx: number) {
    const { tot, total_1 } = this.getListData(rowIdx);

    this.updateListProperty(
      rowIdx,
      'amount',
      Math.round(((tot || 0) * (total_1 || 0)) / this.numberOfDay)
    );
  }

  calcuateOTAmount(rowIdx: number) {
    const { tot, mobile, ot_hr_s, ot_hr } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'ot_amount',
      Math.round(
        (((+tot || 0) - (+mobile || 0)) * ((+ot_hr_s || 0) + (+ot_hr || 0))) /
          240
      )
    );
  }

  calculateTotal_2(rowIdx: number) {
    const { amount, ot_amount } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'total_2',
      Number((+amount || 0) + (+ot_amount || 0))
    );
  }

  calculateTotal_3(rowIdx: number) {
    const {
      total_2 = 0,
      pf = 0,
      esic = 0,
      labour = 0,
    } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'total_3',
      Number(+total_2 - +pf - +esic - +labour)
    );
  }

  calculatePayable(rowIdx: number) {
    const { total_3 = 0, tea = 0, adv = 0 } = this.getListData(rowIdx);
    this.updateListProperty(rowIdx, 'payable', Number(+total_3 - +tea - +adv));
  }

  calculateCashPayable(rowIdx: number) {
    const {
      payable = 0,
      cheque_payment = 0,
      spl_allowance = 0,
    } = this.getListData(rowIdx);
    this.updateListProperty(
      rowIdx,
      'cash_payable',
      Number(+payable - +cheque_payment - +spl_allowance)
    );
  }

  // all totals function
  calculateTotal(key_name: any, update_key_name: any) {
    const total = this.moduleData?.list?.reduce(
      (accumulator: any, currentValue: any) => {
        if (currentValue[key_name]) {
          return (+accumulator || 0) + (+currentValue[key_name] || 0);
        }
        return accumulator;
      },
      0
    );
    this.moduleData[update_key_name] = total;
  }

  handleSalaryCalc(rowIdx: number) {
    this.calculateTotalWorkingDays(rowIdx);
    this.calculatePayAmount(rowIdx);
    this.calcuateOTAmount(rowIdx);
    this.calculateTotal_2(rowIdx);
    this.calculateTotal_3(rowIdx);
    this.calculatePayable(rowIdx);
    this.calculateCashPayable(rowIdx);
  }

  private getListData(rowIdx: number) {
    return this.moduleData.list[rowIdx];
  }

  private updateListProperty(rowIdx: number, property: string, value: any) {
    this.moduleData.list[rowIdx][property] = value;
  }
}
